var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhEyeFill2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:eye-fill"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1255B9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 102",
    cx: 20,
    cy: 20,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57854 17.0259C11.0235 12.4731 14.6768 8.8 19.7775 8.8C26.0612 8.8 31.1561 13.8148 31.1561 20C31.1561 26.1852 26.0612 31.2 19.7775 31.2C18.9931 31.2 18.3555 31.8272 18.3555 32.6C18.3544 32.7827 18.3902 32.9639 18.4611 33.1332C18.5319 33.3024 18.6364 33.4565 18.7684 33.5865C18.9004 33.7165 19.0575 33.8199 19.2307 33.8909C19.4038 33.9618 19.5896 33.9989 19.7775 34C27.6329 34 34 27.7322 34 20C34 12.2678 27.6329 6 19.7775 6C13.3369 6 8.55956 10.5831 6.80944 16.3623L5.60192 14.5997C5.49878 14.4476 5.36557 14.317 5.21003 14.2155C5.0545 14.114 4.87976 14.0436 4.69599 14.0084C4.51221 13.9733 4.32308 13.974 4.1396 14.0106C3.95612 14.0472 3.78197 14.119 3.62728 14.2217C3.31357 14.4319 3.09752 14.7537 3.02587 15.1176C2.95423 15.4816 3.03275 15.8583 3.24444 16.1663L6.42516 20.8087C6.5283 20.9608 6.66152 21.0914 6.81705 21.1929C6.97258 21.2944 7.14732 21.3648 7.3311 21.4C7.51487 21.4352 7.70401 21.4344 7.88748 21.3978L9.57854 17.0259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8614 15.3646L9.57854 17.0259L7.88748 21.3978C8.07096 21.3612 8.24512 21.2894 8.3998 21.1867L12.4532 17.6858C12.7662 17.4754 12.9817 17.1539 13.0533 16.7904C13.1249 16.4269 13.0469 16.0506 12.836 15.7426C12.7329 15.5905 12.5997 15.4599 12.4441 15.3584C12.2886 15.2569 12.1138 15.1865 11.9301 15.1513C11.7463 15.1161 11.5572 15.1169 11.3737 15.1535C11.1902 15.1901 11.0161 15.2619 10.8614 15.3646Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhEyeFill2);
export default __webpack_public_path__ + "static/media/ph_eye-fill2.46758a5bda11063ff06e8cbc44bb1df8.svg";
export { ForwardRef as ReactComponent };